module.exports = __webpack_public_path__ + "img/Oman_logo_ramadan_ar.c4f7f007.png";